import React, { useState, useRef } from "react"
import { Col, Collapse, Form, Label, Row } from "reactstrap"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import classnames from "classnames"
import { post } from "../../../helpers/api_helper"
import { POST_REWRITE_WORK_REPORT } from "../../../helpers/url_helper"

const TeamAccordian = props => {
  const {
    item,
    sethandleAccordion,
    handleAccordion,
    keyId,
    handleChangeReportValue,
    reportValue
  } = props

  const [aiLoading, setAiLoading] = useState(false)
  const [aiSuggestion, setAiSuggestion] = useState(null)
  const [aiError, setAiError] = useState(null)
  const editorRef = useRef(null)

  const handleOnclickAccordion = value => {
    if (handleAccordion === value) {
      sethandleAccordion(null)
    } else {
      sethandleAccordion(value)
    }
  }

  const handleAiRewrite = async () => {
    const currentText = reportValue || item?.reportDetail || ""
    if (!currentText.trim()) return

    setAiLoading(true)
    setAiSuggestion(null)
    setAiError(null)

    try {
      const response = await post(POST_REWRITE_WORK_REPORT, {
        reportText: currentText.replace(/<[^>]*>/g, ""),
      })
      if (response?.statusCode === 200 && response?.rewrittenReport) {
        setAiSuggestion(response.rewrittenReport)
      } else {
        setAiError("Could not rewrite the report. Please try again.")
      }
    } catch {
      setAiError("Failed to connect to AI service. Please try again.")
    } finally {
      setAiLoading(false)
    }
  }

  const handleAcceptSuggestion = () => {
    if (editorRef.current) {
      editorRef.current.setData(aiSuggestion)
    }
    handleChangeReportValue(keyId, aiSuggestion)
    setAiSuggestion(null)
  }

  const handleDiscardSuggestion = () => {
    setAiSuggestion(null)
    setAiError(null)
  }

  const isEmailed = item?.screenVerifiedStatus === "Emailed to Client "

  return (
    <React.Fragment>
      <div className="accordion p-2" id="accordion" key={keyId}>
        <div className="accordion-item mb-2">
          <h2 className="accordion-header" id="headingOne">
            <button
              className={classnames("accordion-button", "fw-medium", {
                collapsed: handleAccordion !== keyId,
              })}
              type="button"
              onClick={() => handleOnclickAccordion(keyId)}
              style={{ cursor: "pointer" }}
            >
              <div className="d-flex d-flex-justspace mobile_accordian">
                <div>
                  Display :{" "}
                  <span className="addposition">{item?.displayName}</span>
                </div>
                <div>
                  Task Name :{" "}
                  <span className="addposition">{item?.taskName}</span>
                </div>
                <div className="taskHours">
                  Task Hours :{" "}
                  <span className="addposition">{item?.taskTotalHours}</span>
                </div>
              </div>
            </button>
          </h2>

          <Collapse
            isOpen={handleAccordion === keyId}
            className="accordion-collapse"
          >
            <div className="accordion-body">
              <div className="text-muted">
                <Row>
                  <Col md="12">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <Label htmlFor="formrow-state-Input" className="mb-0">Report:</Label>
                      {!isEmailed && (
                        <button
                          type="button"
                          className="btn btn-sm btn-soft-primary"
                          onClick={handleAiRewrite}
                          disabled={aiLoading}
                          title="Rewrite with AI"
                        >
                          {aiLoading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-1"
                                role="status"
                                aria-hidden="true"
                              />
                              Rewriting...
                            </>
                          ) : (
                            <>
                              <i className="mdi mdi-auto-fix me-1" />
                              AI Rewrite
                            </>
                          )}
                        </button>
                      )}
                    </div>

                    {isEmailed ? (
                      <div
                        className="input-static-widthteams pre-wrap"
                        style={{
                          background: "#fff",
                          marginBottom: "1.5rem",
                          minHeight: "90px",
                          borderBottomWidth: "2px",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: reportValue || item?.reportDetail,
                        }}
                      />
                    ) : (
                      <Form method="post">
                        <CKEditor
                          editor={ClassicEditor}
                          data={reportValue || item?.reportDetail}
                          onReady={editor => {
                            editorRef.current = editor
                          }}
                          onChange={(event, editor) => {
                            let data = editor.getData()
                            const sanitized = data.replace(/&lt;/g, "").replace(/&gt;/g, "")

                            if (sanitized !== data) {
                              editor.setData(sanitized)
                              setTimeout(() => {
                                const view = editor.editing.view
                                const doc = editor.model.document

                                editor.model.change(writer => {
                                  const root = doc.getRoot()
                                  if (root.childCount > 0) {
                                    const endPosition = root.getChild(root.childCount - 1)
                                    const position = writer.createPositionAt(endPosition, "end")
                                    writer.setSelection(position)
                                  }
                                })

                                view.focus()
                              }, 0)
                            }

                            handleChangeReportValue(keyId, sanitized)
                          }}
                        />
                      </Form>
                    )}

                    {aiError && (
                      <div className="alert alert-danger d-flex align-items-center mt-2 py-2" role="alert">
                        <i className="mdi mdi-alert-circle-outline me-2" />
                        {aiError}
                        <button
                          type="button"
                          className="btn-close ms-auto"
                          onClick={() => setAiError(null)}
                          aria-label="Close"
                        />
                      </div>
                    )}

                    {aiSuggestion && (
                      <div
                        className="border rounded mt-2"
                        style={{ background: "#f8f9fa", overflow: "hidden" }}
                      >
                        <div
                          className="d-flex align-items-center justify-content-between px-3 py-2"
                          style={{ background: "#e8f4fd", borderBottom: "1px solid #dee2e6" }}
                        >
                          <span className="fw-semibold text-primary" style={{ fontSize: "0.85rem" }}>
                            <i className="mdi mdi-auto-fix me-1" />
                            AI Suggestion
                          </span>
                          <div className="d-flex gap-2">
                            <button
                              type="button"
                              className="btn btn-sm btn-success"
                              onClick={handleAcceptSuggestion}
                              title="Apply suggestion"
                            >
                              <i className="mdi mdi-check me-1" />
                              Accept
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-secondary"
                              onClick={handleDiscardSuggestion}
                              title="Keep original text"
                            >
                              <i className="mdi mdi-close me-1" />
                              Discard
                            </button>
                          </div>
                        </div>
                        <div
                          className="px-3 py-2"
                          style={{ fontSize: "0.9rem", color: "#333", whiteSpace: "pre-wrap" }}
                        >
                          {aiSuggestion}
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
            </div>
          </Collapse>
        </div>
      </div>
    </React.Fragment>
  )
}

export default TeamAccordian
